// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__Kfxw9","list":"BalanceDue_list__31J9T","listRow":"BalanceDue_listRow__3bvEb","total":"BalanceDue_total__Jo-K9"};